export default __webpack_public_path__ + "static/media/image_1.2eb14424.jpg";